import $ from 'jquery';
import Swal from 'sweetalert2';
import { submitSubscribesForm, callSubscribesForm } from './subcribesForm.js';

export const userSubscribe = () => {
  // Função de inscrição do usuário
  function subscription(challengeId) {
    $.ajax({
      type: 'POST',
      url: '/efetuar-inscricao/',
      data: {
        challenge_id: challengeId,
        _token: $('meta[name="csrf-token"]').attr('content'),
      },
      dataType: 'json',
      success: function (data) {
        if (data.type === 'success') {
          Swal.fire('Sucesso!', 'Inscrição concluída com sucesso!', 'success').then(function () {
            window.location.reload();
          });
        } else {
          Swal.fire(data.title, data.message, data.type);
        }
      },
    });
  }

  // Envia a função de inscrição do usuário para a função de submit do formulário
  submitSubscribesForm(subscription);

  // Evento do botão de participar
  $(document).on('click', '[data-type="participate"]', function (e) {
    e.preventDefault();
    let challengeId = $(this).attr('data-challenge'),
      isForm = $(this).is('[data-form]');

    if (isForm) {
      callSubscribesForm(challengeId);
    } else {
      subscription(challengeId);
    }
  });

  // Evento do botão de desparticipar
  $(document).on('click', '[data-type="disparticipate"]', function (e) {
    e.preventDefault();

    Swal.fire({
      title: 'Você tem certeza que quer deixar de participar desta ação?',
      showCancelButton: true,
      confirmButtonColor: '#9C63FF',
      cancelButtonColor: '#d33',
      cancelButtonText: 'NÃO TENHO',
      confirmButtonText: 'SIM, TENHO',
      padding: '50px',
      reverseButtons: true,
      customClass: 'c-new-swal',
    }).then(result => {
      if (result.value) {
        let challengeId = $(this).attr('data-challenge'),
          isInternal = false;

        if ($('body').attr('data-controller') == 'challenges' && $('body').attr('data-action') == 'show') {
          isInternal = true;
        }

        $.ajax({
          type: 'POST',
          url: '/cancelar-inscricao/',
          data: {
            challenge_id: challengeId,
            _token: $('meta[name="csrf-token"]').attr('content'),
          },
          dataType: 'json',
          success: function (data) {
            if (data.type === 'success') {
              window.location.reload();
            } else {
              Swal.fire(data.title, data.message, data.type);
            }
          },
        });
      }
    });
  });
};
